<template>
	<b-container id="generate-picture-file" v-if="$can('view-generate-picture-file') || $can('view-all')" fluid>
        <b-row class="page-title">
            <b-container fluid>
                <h3>Generate Picture File</h3>
                <hr>
            </b-container>
        </b-row>

        <b-row class="button-row">
            <b-col cols="3">
                <b-button size="sm" variant="outline-dark" @click="exportExcel"><i class="fas fa-file-excel fa-2x"></i> Excel</b-button>
                <b-button size="sm" variant="outline-dark" @click="exportPDF"><i class="fas fa-file-pdf fa-2x"></i> PDF</b-button>
                <b-button size="sm" variant="outline-dark" @click="openModal('excel-paste')"><i class="fas fa-paste fa-2x"></i> PASTE CSV</b-button>
            </b-col>
            <b-col>
                <b-form-input v-model="headerText" size="sm" placeholder="Header Text"></b-form-input>
            </b-col>
            <b-col class="text-right">
                <b-button size="sm" variant="outline-danger" @click="resetView"><i class="fas fa-redo fa-2x"></i> Reset View</b-button>
            </b-col>
        </b-row>

        <b-table-simple hover small responsive bordered sticky-header="550px">
            <b-thead>
                <b-tr>
                    <b-th class="text-center"></b-th>
                    <b-th class="text-center">Photo</b-th>
                    <b-th>SKU</b-th>
                    <b-th class="qty text-center">QTY</b-th>
                    <b-th colspan="3" class="qty text-center">Status</b-th>
                    <b-th>
                        <b-container fluid>
                            <b-row>
                                <b-col>Title</b-col>
                                <b-col class="text-right">
                                    <b-form-checkbox
                                        id="checkbox-title"
                                        v-model="show.title"
                                        name="checkbox-title"
                                        :value="true"
                                        :unchecked-value="false"
                                        >
                                    </b-form-checkbox>
                                </b-col>
                            </b-row>
                        </b-container>
                    </b-th>
                    <b-th class="price text-center">
                        <b-container fluid>
                            <b-row>
                                <b-col >Price</b-col>
                                <b-col class="text-right">
                                    <b-form-checkbox
                                        id="checkbox-price"
                                        v-model="show.price"
                                        name="checkbox-price"
                                        :value="true"
                                        :unchecked-value="false"
                                        >
                                    </b-form-checkbox>
                                </b-col>
                            </b-row>
                        </b-container>
                    </b-th>
                    <b-th class="price text-center">Discount Price</b-th>
                    <b-th class="price text-center">% Discount</b-th>
                    <b-th class="price text-center">Total</b-th>
                    <b-th>Notes</b-th>
                </b-tr>
            </b-thead>
            <b-tbody>
                <b-tr v-for="(item, index) in row.items" :key="index" :class="`index-${index}`">
                    <td class="text-center"><b-button size="sm" variant="danger" @click="deleteRow(index)"><i class="far fa-trash-alt fa-sm"></i></b-button></td>
                    <td class="text-center">
                        <b-img-lazy v-if="row.items[index].url" class="products-thumbs" :src="item.url"></b-img-lazy>
                    </td>
                    <td>
                        <div class="options-assign">
                            <div class="autosuggest-container">
                                <vue-autosuggest
                                    v-model="row.items[index].sku"
                                    :suggestions="autosuggest.suggestions"
                                    @focus.once="focusMe(index)"
                                    @click="clickHandler"
                                    @input="fetchResults"
                                    @selected="onSelected"
                                    @keydown.tab="onKeyTab"
                                    :get-suggestion-value="getSuggestionValue"
                                    :input-props="{id:'autosuggest__input_' + index, placeholder:''}"
                                    @keyup.enter="suggestFirst(index, $event.target.value)"
                                    :ref="'input' + index"
                                >

                                <b-container slot-scope="{suggestion}" fluid>
                                    <b-row>
                                        <b-col cols="2">
                                            <b-img-lazy class="products-thumbs" :src="suggestion.item.url"></b-img-lazy>
                                        </b-col>
                                        <b-col class="text-right">
                                            {{ suggestion.item.name }}
                                        </b-col>
                                    </b-row>
                                </b-container>
                            </vue-autosuggest>
                            </div>
                        </div>
                    </td>
                    <td>
                        <b-form-input v-model="row.items[index].qty" size="sm" class="text-center" @input="calculateRow(index)"></b-form-input>
                    </td>
                    <td colspan="3" class="text-center">
                        <b-form-radio-group v-model="row.items[index].status">
                            <b-form-radio v-for="status in statusOptions" :key="status.id" :value="status.value">{{ status.label }}</b-form-radio>
                        </b-form-radio-group>
                    </td>
                    <td>
                        <b-form-input v-model="row.items[index].title" size="sm" v-bind:class="{ 'hide-data': show.title == false }" readonly></b-form-input>
                    </td>
                    <td>
                        <b-form-input v-model="row.items[index].price" size="sm" v-bind:class="{ 'hide-data': show.price == false }" class="text-center" readonly @change="calculateRow(index)" @input="calculateRow(index)"></b-form-input>
                    </td>
                    <td>
                        <b-form-input v-model="row.items[index].discountPrice" size="sm" class="text-center" @input="calculateRow(index)" :readonly="row.items[index].percentDiscount.length ? true : false"></b-form-input>
                    </td>
                    <td>
                        <b-form-input v-model="row.items[index].percentDiscount" size="sm" class="text-center" @input="calculateRow(index)":readonly="row.items[index].discountPrice.length ? true : false"></b-form-input>
                    </td>
                    <td>
                        <b-form-input v-model="row.items[index].total" size="sm" class="text-center" readonly></b-form-input>
                    </td>
                    <td>
                        <b-form-input v-model="row.items[index].notes" size="sm"></b-form-input>
                    </td>
                </b-tr>
            </b-tbody>
        </b-table-simple>

        <b-row>
            <b-col cols="1">
                <b-button size="sm" @click="addTenRows"><i class="fas fa-plus"></i> 10</b-button>
            </b-col>
        </b-row>

        <modal-excel-paste
            v-if="modals['modal-inventory-generatepicturefile-excel-paste'].active"
            @updateRowItems="updateRowItems"
        />
    </b-container>
</template>

<script>
    import { VueAutosuggest } from "vue-autosuggest"
    import ModalExcelPaste from './modals/ExcelPaste'
    import { debounce } from 'vue-debounce'
	export default {
        name: 'GeneratePictureFile',

        metaInfo() {
            return {
                title: 'Generate Picture File',
            }
        },

        components: {
            VueAutosuggest,
            'modal-excel-paste': ModalExcelPaste,
        },

		data() {
            return {
                statusOptions: [
                    { id: 1, label: 'New', value: 'new' },
                    { id: 2, label: 'OOS', value: 'oos' },
                    { id: 3, label: 'BIS', value: 'bis' },
                ],
                modals: {
                    'modal-inventory-generatepicturefile-excel-paste': {
                        active: 0
                    },
                },

                show: {
                    title: true,
                    price: true
                },

                autosuggest: {
                    suggestions: [],
                    debounceMilliseconds: 500,
                    timeout: null
                },

                cacheKey: 1,

                row: {
                    items: []
                },
                locations: ['A', 'B'],
                headerText: '',
                products: [
                    {
                        data: []
                    }
                ],
                currentIndex: ''
			}
		},

		methods: {
            openModal(modalName, row, area) {
                let prefix = 'modal-inventory-generatepicturefile-'
                switch (modalName) {
                    case 'excel-paste':
                            this.modals[prefix + modalName].active = 1
                        break;
                }

                this.$nextTick(() => {
                    this.$bvModal.show(prefix + modalName)
                })
            },

            updateRowItems(rows) {
                this.row.items = rows
            },

            deleteRow(index) {
                this.row.items.splice(index, 1)
            },

            scrollToElement(options, index) {
                this.$nextTick(() => {
                    const el = this.$el.getElementsByClassName('index-' + index)[0];

                    if (el) {
                        el.scrollIntoView(options);
                    }
                })
            },

            addTenRows() {
                for (var index = 0; index <= 10; index++) {
                    this.row.items.push({sku: '', qty: '', price: '', title: '', discountPrice: '', total: '', percentDiscount: '', notes: '', url: ''})
                }
            },

            renderOptions(area) {
                if (area == 'from') {
                    if (this.row.to == this.row.from) {
                        this.locations.forEach((loc, idx, array) => {
                            if (loc != this.row.from) {
                                this.row.to = this.locations[idx]
                            }
                        })

                    }
                } else {
                    if (this.row.from == this.row.to) {
                        this.locations.forEach((loc, idx, array) => {
                            if (loc != this.row.to) {
                                this.row.from = this.locations[idx]
                            }
                        })

                    }
                }
            },

            getValidationState({ dirty, validated, valid = null }) {
                return dirty || validated ? valid : null;
            },

            fetchResults() {
                const query = this.row.items[this.currentIndex].sku

                clearTimeout(this.autosuggest.timeout)
                this.autosuggest.timeout = setTimeout(() => {
                    const productsPromise = axios.get('api/inventory/generatepicturefile/getproductsfilter/' + query)

                    Promise.all([productsPromise]).then(values => {
                        this.autosuggest.suggestions = []

                        // const products = this.filterResults(values[0].data, query, 'name')
                        const products = values[0].data.items

                        products.length &&
                        this.autosuggest.suggestions.push({ name: "products", data: products })
                    })
                }, this.autosuggest.debounceMilliseconds)
            },

            filterResults(data, text, field) {
                return data.items
                    .filter(item => {
                        if (item[field].toLowerCase().indexOf(text.toLowerCase()) > -1) {
                            return item[field]
                        }
                    })
                    .sort()
            },

            calculateRow(index) {
                let qty = this.row.items[index].qty ? this.row.items[index].qty : 0
                let price = this.row.items[index].price ? this.row.items[index].price : 0
                let discountPrice = this.row.items[index].discountPrice ? this.row.items[index].discountPrice : 0
                let percentDiscount = this.row.items[index].percentDiscount ? this.row.items[index].percentDiscount : 0

                let totalBeforeDiscount = qty * price
                let total

                if (discountPrice) {
                    total = (discountPrice * qty).toFixed(2)
                } else if (percentDiscount) {
                    let discount = Math.round((price - (price * (percentDiscount * 0.01)) + Number.EPSILON) * 100) / 100
                    total = (qty * discount).toFixed(2)
                } else {
                    total = totalBeforeDiscount.toFixed(2)
                }

                this.row.items[index].total = total > 0 ? total : ''
            },

            clickHandler(item) {
                let query = this.row.items[this.currentIndex].sku;
                if (!query) {
                    this.autosuggest.suggestions = []
                    this.row.items[this.currentIndex].title = ''
                    this.row.items[this.currentIndex].price = ''
                    this.row.items[this.currentIndex].url = ''
                }
            },

            onSelected(item) {
                if (item) {
                    this.row.items[this.currentIndex].sku = item.item.name
                    this.row.items[this.currentIndex].title = item.item.title
                    this.row.items[this.currentIndex].price = item.item.price
                    this.row.items[this.currentIndex].url = item.item.url
                }
            },

            onInputChange(text) {
                // console.log(text)
              // event fired when the input changes
              // console.log(text)
            },

            onItemChanged(text) {
                // this.row.items[this.currentIndex].sku = text.item.name
            },

            onKeyTab(evt) {
                // evt.preventDefault()
                let query = this.row.items[this.currentIndex].sku.toUpperCase()

                setTimeout(() => {
                    if (this.autosuggest.suggestions.length) {
                        let results = this.autosuggest.suggestions[0].data

                        let resultName = results[0].name

                        if (resultName == query) {
                            this.row.items[this.currentIndex].sku = results[0].name
                            this.row.items[this.currentIndex].title = results[0].title
                            this.row.items[this.currentIndex].price = results[0].price
                            this.row.items[this.currentIndex].url = results[0].url
                            this.autosuggest.suggestions = []
                        } else {
                            this.autosuggest.suggestions = []
                        }
                    }
                }, 1500)
            },

            getSuggestionValue(suggestion) {
                return suggestion.item.name
            },

            focusMe(index) {
                this.currentIndex = index

                if (this.row.items.length == index + 1) {
                    this.row.items.push({sku: '', qty: '', price: '', title: '', discountPrice: '', total: '', percentDiscount: '', notes: '', url: ''})

                    this.scrollToElement({behavior: 'smooth'}, index + 1)
                }

            },

            suggestFirst(index, query) {
                let hasQuery = this.row.items[index].sku

                if (hasQuery) {
                    let suggests = this.autosuggest.suggestions
                    if (typeof suggests[0] !== 'undefined') {
                        let arr = suggests[0].data

                        if (arr.length) {
                            for (var i = 0; i < arr.length; i++) {
                                let cur = arr[i].name.toLowerCase()
                                if (cur.includes(query.toLowerCase())) {
                                    this.row.items[index].sku = arr[i].name
                                    this.row.items[index].title = arr[i].title
                                    this.row.items[index].price = arr[i].price
                                    this.row.items[index].url = arr[i].url
                                    this.autosuggest.suggestions = []

                                    break;
                                } else {
                                    continue
                                }
                            }
                        }
                    } else {
                        let target = 'input' + (index + 1)
                        this.$refs[target][0].$el.childNodes[0].childNodes[0].focus()
                    }
                } else {
                    let target = 'input' + (index + 1)
                    this.$refs[target][0].$el.childNodes[0].childNodes[0].focus()
                }
            },

            filteredOptions(index) {
                return [
                    {
                        data: this.products[0].data.filter(option => {
                            return option.name.toLowerCase().indexOf(this.row.items[index].sku.toLowerCase()) > -1
                        })
                    }
                ]
            },

            forceFileDownload(response, ext){
                const url = window.URL.createObjectURL(new Blob([response.data]))
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', 'Generated_Picture_File_' + +new Date() + '.' + ext) //or any other extension
                document.body.appendChild(link)
                link.click()

                this.showAlertBox('success', 'File Generated', 'Picture file generated successfully!')
            },

            exportExcel() {
                let url = 'api/inventory/generatepicturefile/exportexcel'
                axios.post(url, {
                    rows: this.row.items,
                    show: this.show,
                    headerText: this.headerText
                },
                {
                    responseType: 'blob'
                })
                .then((res) => {
                    this.forceFileDownload(res, 'xlsx')
                }, () => {
                    this.has_error = true
                })
            },

            exportPDF() {
                let url = 'api/inventory/generatepicturefile/exportpdf'
                axios.post(url, {
                    rows: this.row.items,
                    show: this.show,
                    headerText: this.headerText
                },
                {
                    responseType: 'blob',
                })
                .then((res) => {
                    this.forceFileDownload(res, 'pdf')
                }, () => {
                    this.has_error = true
                })
            },

            resetView() {
                this.row.items = []
                this.headerText = ''

                for (var index = 0; index <= 25; index++) {
                    this.row.items.push({sku: '', qty: '', price: '', title: '', discountPrice: '', total: '', percentDiscount: '', notes: '', url: ''})
                }

                this.currentIndex = ''
            }
		},

        mounted() {
            this.resetView()

            this.$root.$on('bv::modal::hidden', (bvEvent, modalId) => {
                switch (modalId) {
                    case 'modal-inventory-generatepicturefile-excel-paste':
                        this.modals[modalId].active = 0

                        break
                }
            })
        }
	}
</script>

<style lang="scss">
    #generate-picture-file {
        .button-row {
            margin-bottom: 5px;

            .fa-file-excel {
                color: green;
            }

            .fa-file-pdf {
                color: red;
            }
        }

        table {
            td {
                vertical-align: middle;
            }

            input {
                width: 100%;
            }

            .qty {
                width: 60px;
            }

            .price {
                width: 110px;
            }

            .hide-data {
                text-decoration: line-through;
            }

            .products-thumbs {
                width: 50px;
                max-height: 50px;
            }
        }

        .options-assign {
            font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;

            input {
                width: 100%;
                padding: 0.5rem;
                height: calc(1.5em + 0.3rem + 2px);
            }

            ul {
                width: 100%;
                color: rgba(30, 39, 46,1.0);
                list-style: none;
                margin: 0;
                padding: 0.5rem 0 .5rem 0;
            }

            li {
                margin: 0 0 0 0;
                border-radius: 5px;
                padding: 0.75rem 0 0.75rem 0.75rem;
                display: flex;
                align-items: center;
            }

            li:hover {
                cursor: pointer;
            }

            .autosuggest-container {
                display: flex;
                // justify-content: center;
                width: 100%;

                li {
                    white-space: nowrap;
                    text-align: left;
                }
            }

            #autosuggest { width: 100%; display: block; }

            .autosuggest__results {
                position: relative;
            }

            .autosuggest__results-container {
                width: 300px;
            }

            .autosuggest__results-item--highlighted {
                background-color: rgba(51, 217, 178,0.2);
            }

            #autosuggest-autosuggest__results {
                overflow-y: hidden;
                // max-height: 200px;
            }
        }
    }
</style>
